import MixedChartBlock from './MixedChartBlock';

export default MixedChartBlock;
